import { SmartAction } from '@connect-x-app/shared-domain-models';
import { FormValidator, ValidatorResponse } from '@connect-x-app/shared-utils';
import { FormValidationErrors } from '@connect-x-app/web-state';

const nameValidation = (validator: FormValidator, name: string): ValidatorResponse | undefined => {
  const requiredValidation = validator.required(name);
  if (!requiredValidation.isValid) {
    return requiredValidation;
  }

  if (name) {
    const maxLengthValidation = validator.maxLength(name, 100);

    if (!maxLengthValidation.isValid) {
      return maxLengthValidation;
    }

    const alphaNumericValidation = validator.isAlphaNumeric(name, true);

    if (!alphaNumericValidation.isValid) {
      return alphaNumericValidation;
    }
  }

  return undefined;
};

export const validateSmartActionForm = (values: SmartAction): FormValidationErrors<SmartAction> => {
  const validator = new FormValidator();

  return {
    description: validator.maxLength(values?.description ?? '', 100),
    name: nameValidation(validator, values?.name),
    url: values.isDefault ? undefined : validator.required(values?.url),
  };
};
